import * as e from "react";
export function useCallbackRef(r) {
  var t = e.useRef(r);
  return e.useEffect(function () {
    t.current = r;
  }), e.useMemo(function () {
    return function () {
      var _r;
      var r;
      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }
      return null === (r = t.current) || void 0 === r ? void 0 : (_r = r).call.apply(_r, [t].concat(e));
    };
  }, []);
}